import { ESTIMATED_FIELDS } from "./consts";
import { isEmpty } from "./helpers";

const CLIENT_REQUIRED_FIELDS = {
  estimated: [
    "firstName",
    "lastName",
    "email",
    "phone",
    "address",
    "city",
    "state",
    "zip",
    "description",
    "sq_feet",
    "special_attention",
  ],

  blackmanpi: ["firstName", "lastName", "email", "phone", "description"],

  purewaternorthwest: [
    "firstName",
    "lastName",
    "email",
    "phone",
    "address",
    "city",
    "state",
    "zip",
    "description",
    "customerType",
    "homeOwner",
    "numOfPeople",
    "numOfBathroom",
    "wellType",
  ],

  rpi_google: ["firstName", "lastName", "email", "phone", "zip"],

  westover: [
    "firstName",
    "lastName",
    "email",
    "phone",
    "address",
    "city",
    "state",
    "zip",
    "description",
    "firstWorkDay",
  ],

  triangleconciergephysiotherapy: ["firstName", "lastName", "phone"],

  default: ["firstName", "lastName", "email", "phone", "address", "city", "state", "zip", "description"],
};

const validateForm = (form, client_id) => {
  let requiredFields = CLIENT_REQUIRED_FIELDS.default;

  if (ESTIMATED_FIELDS.includes(client_id)) {
    requiredFields = CLIENT_REQUIRED_FIELDS.estimated;
  } else if (CLIENT_REQUIRED_FIELDS[client_id]) {
    requiredFields = CLIENT_REQUIRED_FIELDS[client_id];
  }

  // Returns true if form is invalid
  return requiredFields.some((field) => isEmpty(form[field]));
};

export { validateForm };
